export var discountInfoKeyNameMapping = { en: "discountEName", hk: "discountNameHk", cn: "discountNameCn" };
export var CONSTANTS = { EMPTY: "EMPTY", DISCOUNT_CODE: "discountCode" };
